import { FC } from 'react';
import { getSymbolFromCurrency } from './currencySymbolMapHelper';

interface CurrencyDisplayWrapperProps {
  currencyCode?: string;
  children: string | JSX.Element | JSX.Element[] | undefined;
  className?: string;
}

export const CurrencyDisplayWrapper: FC<CurrencyDisplayWrapperProps> = ({
  currencyCode,
  children,
  className
}) => {
  return (
    <>
      <div className={`truncate ${className ?? ''}`}>
        {currencyCode ? getSymbolFromCurrency(currencyCode) : null}
        {children}
      </div>
    </>
  );
};
